import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

import Home from "./containers/Home/Home";
import NotFound from "./containers/NotFound/NotFound";
import Download from "./containers/Download/Download";
import Services from "./containers/Services/Services";
import Dashboard from "./containers/Dashboard/Dashboard";

export default () => {
  return (
    <div className="App">
      <Router>
        <Switch>
          <Route path="/" component={Home} exact />
          <Route path="/dashboard" component={Dashboard} exact />
          <Route path="/download" component={Download} exact />
          <Route path="/services" component={Services} exact />
          <Route path="*" component={NotFound} />
        </Switch>
      </Router>
    </div>
  );
};
